export const CONSTANTSSTATUS = {
  statusSchedule: 'Scheduled',
  statusschedule: 'scheduled',
  statusAccepted: 'Accepted',
  statusCancelled: 'Cancelled',
  statusCompleted: 'Completed',
  statusUnsuccessful: 'Unsuccessful',
  statusOngoing: 'Ongoing',
  statusDeniedByPatient: 'DeniedByPatient',
  statusDenied: 'Denied',
  userPatientType: 'guest_patient',
  userPatientTypeDoctor: 'Doctor',
  userTypeNurse: 'Enfermero(a)',
  start: 'Start',
  started: 'started',
  Timeout: 'Timeout',
  End: 'End',
  statusUpcomingCaps: 'UPCOMING',
  statusCanceledCaps: 'CANCELLED',
  statusCompletedCaps: 'COMPLETED',
  statusUnsuccessfulCaps: 'UNSUCCESSFUL',
  userAdmin: 'Administrador(a)',
  statusPending: 'pending',
  imageBaseUrl: '../../../../assets',
  successCode: 200,
  statusTrue: true,
};
export const CONSTGENDER = {
  Male: 'Male',
  Female: 'Female',
  Nonbinary: 'Non-binary',
  Transgender: 'Transgender',
  Intersex: 'Intersex',
  prefer: 'I prefer not to say',
};
export const CONSTSTATUS = {
  successfulRes: 200,
  lastAppointmentStatus: '1',
  listAppointmentLimit: 5,
  positiveStatus: '1',
  negetiveStatus: '0',
};

export const CONSTAPPOINTMENTTYPE = 'Online Visit';
export const CONSTUSERROLETYPE = {
  doctor: 'doctor',
  nurse: 'nurse',
  admin: 'admin',
};
export const CONSTAPPTTYPE = 'Online';
export const CONSTSFGENTYPE = {
  Male: 'M',
  Female: 'F',
  Other: 'O',
  GMale: 'Male',
  GFemale: 'Female',
  GOther: 'Other',
};
export const CONSTSTATUSTYPE = {
  Upcoming: 'Upcoming',
  Successful: 'Successful',
  Unsuccessful: 'Unsuccessful',
  Ongoing: 'Ongoing',
};
export const CONSTAPPOINTMENTSTATUSTYPE = {
  UPCOMING: 'scheduled',
  COMPLETED: 'completed',
  UNSUCCESSFUL: 'unsuccessful',
  CANCELLED: 'canceled',
};
